import { trackInternalEvent } from '@rio/tracking'
import { useMediaQueries } from 'builder/hooks/useMediaQueries'
import { useFeaturesConfig } from 'builder/hooks/featureConfig/useFeaturesConfig'

import { Service } from '../../../types'
import { GetPromotionInfo, Steps } from './hooks/useGetPromotionConfig'
import { useGetPromotionActions } from './hooks/useGetPromotionActions'

import * as Styles from './styles'

type ActionButtonsProps = {
  status: 'initial' | 'progress' | 'completed'
  steps: Steps
  text: GetPromotionInfo
  service: Service
}

export const ActionButtons = ({ steps, text, service, status }: ActionButtonsProps) => {
  const { isPhone } = useMediaQueries()
  const { features } = useFeaturesConfig()
  const { handleGetPromotionPage, handleOpenBookCoach } = useGetPromotionActions()

  const openPromotionPage = () => {
    trackInternalEvent('progress_cta_click', {
      score: service.title,
      cta: text.promotion_button,
    })
    handleGetPromotionPage()
  }

  const openBookCoach = () => {
    trackInternalEvent('progress_cta_click', {
      score: service.title,
      cta: text.coach_button,
    })
    handleOpenBookCoach()
  }

  const showScore = (completed?: boolean, score?: number, testId?: string) => {
    if (isPhone) return null
    if (completed) {
      return (
        <Styles.IconContainer data-testid={`${testId}-completed-icon`}>
          <Styles.Icon />
        </Styles.IconContainer>
      )
    }
    return <Styles.ScoreText data-testid={`${testId}-score`}>+{score}%</Styles.ScoreText>
  }

  return (
    <Styles.ProgressActionButtonsContainer data-testid={`get-promotion-action-buttons-${status}`}>
      <Styles.ButtonContainer
        data-testid={
          isPhone ? 'get-promotion-plan-button-mobile' : `get-promotion-plan-button-${status}`
        }
        onClick={openPromotionPage}
      >
        <Styles.ActionText>
          {isPhone ? text.promotion_button_mobile : text.promotion_button}
        </Styles.ActionText>
        {showScore(
          steps.get_promotion?.completed,
          steps.get_promotion?.score,
          'get-promotion-page-seen',
        )}
      </Styles.ButtonContainer>
      {features.careerCoaching && (
        <Styles.ButtonContainer
          data-testid={`get-promotion-book-coach-button-${status}`}
          onClick={openBookCoach}
        >
          <Styles.ActionText>{text.coach_button}</Styles.ActionText>
          {showScore(
            !steps.get_promotion?.completed || steps.career_coaching?.completed,
            steps.career_coaching?.score,
            'get-promotion-career-coaching',
          )}
        </Styles.ButtonContainer>
      )}
    </Styles.ProgressActionButtonsContainer>
  )
}
